import HTML from '../assets/html.png'
import CSS from '../assets/css.png'
import JS from '../assets/javascript.png'
import ReactIcon from '../assets/react.png'
import NodeIcon from '../assets/node.png'
import MongoIcon from '../assets/mongo.png'
import TailwindIcon from '../assets/tailwind.png'
import GithubIcon from '../assets/github.png'
import PostgresIcon from '../assets/postgres.png'
import ExpressIcon from '../assets/express.png'
import MaterialUIIcon from '../assets/MUI.png'
import PythonIcon from '../assets/python.png'
import QtIcon from '../assets/qt.png'
import RedisIcon from '../assets/redis.png'
import CppIcon from '../assets/cpp.png'
import FigmaIcon from '../assets/figma.png'
import AnsibleIcon from '../assets/ansible.png'
import LinuxIcon from '../assets/linux.png'
import DockerIcon from '../assets/docker.png'
import KubernetesIcon from '../assets/kubernetes.png'
import JenkinsIcon from '../assets/jenkins.png'
import AWSIcon from '../assets/aws.png'
import TerraformIcon from '../assets/terraform.png' 

export const data = [
  {
    id: 1,
    image: HTML,
    name: 'HTML',
  },
  {
    id: 2,
    image: CSS,
    name: 'CSS',
  },
  {
    id: 3,
    image: JS,
    name: 'JavaScript',
  },
  {
    id: 4,
    image: ReactIcon,
    name: 'React',
  },
  {
    id: 5,
    image: NodeIcon,
    name: 'Node.js',
  },
  {
    id: 6,
    image: MongoIcon,
    name: 'MongoDB',
  },
  {
    id: 7,
    image: TailwindIcon,
    name: 'Tailwind CSS',
  },
  {
    id: 8,
    image: GithubIcon,
    name: 'GitHub',
  },
  {
    id: 9,
    image: PostgresIcon,
    name: 'PostgreSQL',
  },
  {
    id: 10,
    image: ExpressIcon,
    name: 'Express.js',
  },
  {
    id: 11,
    image: MaterialUIIcon,
    name: 'Material-UI',
  },
  {
    id: 12,
    image: RedisIcon,
    name: 'Redis',
  },
  {
    id: 13,
    image: PythonIcon,
    name: 'Python',
  },
  {
    id: 14,
    image: QtIcon,
    name: 'Qt5',
  },
  {
    id: 15,
    image: CppIcon,
    name: 'C++',
  },
  {
    id: 16,
    image: FigmaIcon,
    name: 'Figma',
  },
  {
    id: 17,
    image: AnsibleIcon,
    name: 'Ansible',
  },
  {
    id: 18,
    image: LinuxIcon,
    name: 'Linux',
  },
  {
    id: 19,
    image: DockerIcon,
    name: 'Docker',
  },
  {
    id: 20,
    image: KubernetesIcon,
    name: 'Kubernetes',
  },
  {
    id: 21,
    image: JenkinsIcon,
    name: 'Jenkins',
  },
  {
    id: 22,
    image: AWSIcon,
    name: 'AWS',
  },
  {
    id: 22,
    image: TerraformIcon,
    name: 'Terraform',
  }
];